"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryEInstant = void 0;
var HistoryEInstantsList_1 = require("./HistoryEInstantsList");
// tslint:disable:variable-name
var HistoryEInstant = /** @class */ (function () {
    function HistoryEInstant(data) {
        this.transactionID = data.transactionID;
        this.transactionDate = data.transactionDate;
        this.playerId = data.playerId;
        this.provider = data.provider;
        this.gameID = data.gameID;
        this.gameName = data.gameName;
        this.group = data.group;
        this.subGroup = data.subGroup;
        this.platform = data.platform;
        this.purchaseAmount = data.purchaseAmount;
        this.tickets = data.tickets;
        this.freeTickets = data.freeTickets;
        this.mode = data.mode;
        this.cancellable = data.cancellable;
        this.requestProvider = data.requestProvider;
        this.gameImageUrl = data.gameImageUrl;
    }
    HistoryEInstant.JsonToEInstants = function (data) {
        var einstantsList = new HistoryEInstantsList_1.HistoryEInstantsList();
        data.forEach(function (einstant) { return einstantsList.push(HistoryEInstant.JsonToEInstant(einstant)); });
        return einstantsList.getTransactionDateSorted();
    };
    HistoryEInstant.JsonToEInstant = function (data) { return new HistoryEInstant(data); };
    return HistoryEInstant;
}());
exports.HistoryEInstant = HistoryEInstant;
//# sourceMappingURL=HistoryEInstant.js.map